import io from 'socket.io-client';

const Socket = io("https://campusroot.com/",{transports:['websocket']})

export default Socket;